import smartSolveApi from './instances/smartsolve';
import { downloadFile } from '../utils/domUtils';

export const getEntityInfo = async (params) => {
  try {
    const response = await smartSolveApi.post('/entity/getentityinfo', params);
    return response.data;
  } catch (e) {
    throw new Error(`getEntityInfo() failed: ${e}`);
  }
};

export const getFieldTypes = async () => {
  try {
    const response = await smartSolveApi.post('entity/fieldTypes', {});
    return response.data;
  } catch (e) {
    throw new Error(`getFieldTypes() failed: ${e}`);
  }
};

export const saveEntity = async (params) => {
  try {
    const response = await smartSolveApi.post('/entity/save', params);
    return response.data;
  } catch (error) {
    throw new Error(`saveEntity() failed: ${error}`);
  }
};

export const publishEntity = async (params) => {
  try {
    const response = await smartSolveApi.post('/entity/publish', params);
    return response.data;
  } catch (error) {
    throw new Error(`publishEntity() failed: ${error}`);
  }
};

export const deleteEntity = async (params) => {
  try {
    const response = await smartSolveApi.post('/entity/delete', params);
    return response.data;
  } catch (error) {
    throw new Error(`deleteEntity() failed: ${error}`);
  }
};

export const exportEntity = async ({ entityId, fileName = 'entity_definition' }) => {
  try {
    const response = await smartSolveApi.post('/entity/export', { entityId });
    downloadFile(`${fileName}.xml`, response.data, 3);
  } catch (error) {
    throw new Error(`exportEntity() failed: ${error}`);
  }
};

export const verifyEntityExists = async (params) => {
  try {
    const response = await smartSolveApi.post('/entity/verifyentityexists', params);
    return response.data.entityExists;
  } catch (e) {
    throw new Error(`verifyEntityExists() failed: ${e}`);
  }
};

export const getNewEntityTemplate = async (params) => {
  try {
    const response = await smartSolveApi.post('/entity/newentitytemplate', params);
    return response.data;
  } catch (e) {
    throw new Error(`getNewEntityTemplate() failed: ${e}`);
  }
};

export const importEntity = async (file) => {
  try {
    const formData = new FormData();

    formData.append('FileName', file.name);
    formData.append('FileStream', file);

    const response = await smartSolveApi.post('/entity/import', formData);
    return response.data;
  } catch (error) {
    throw new Error(`importEntity() failed: ${error}`);
  }
};

export const getListOptions = async () => {
  try {
    const response = await smartSolveApi.post('/entity/listoptions');
    return response.data;
  } catch (e) {
    throw new Error(`getListOptions() failed: ${e}`);
  }
};

export const getListParentFilter = async (params) => {
  try {
    const response = await smartSolveApi.post('/entity/listparentfilter', params);
    return response.data;
  } catch (e) {
    throw new Error(`getListParentFilter() failed: ${e}`);
  }
};

export const recreateTemplates = async (params) => {
  try {
    const response = await smartSolveApi.post('/entity/recreatetemplates', params);
    return response.data;
  } catch (e) {
    throw new Error(`recreateTemplates() failed: ${e}`);
  }
};
